module.exports = __webpack_public_path__ + "img/waxlight-mobile.9df6826f.jpg";